<template>
  <div>
    <div id="myGraph" style="height: 100%"></div>
    <div v-if="suggestions.length === 0" style="height: 100%;width: 100%;position: absolute; top: 0">
      <div class="text-center" style="margin-top: 150px">No suggestions</div>
    </div>
  </div>

</template>

<style>
  @import '../../assets/css/gojs/FoamTreeContextMenu.css';
</style>

<script>
import {Tooltip} from 'tau-tooltip'
import '../../assets/scripts/visualization/carrotsearch.foamtree.js'

export default {
  components: {},
  name: 'FoamTreeSuggestionsBox',
  props: ['suggestions', 'biblio', 'height'],
  data: function () {
    return {
      faom: null,
      suggestionsDatas: [
        { label: 'Your', weight: 1.0 },
        { label: 'First', weight: 3.0 },
        { label: 'FoamTree', weight: 2.0 },
        { label: 'Visualization', weight: 4.0 }
      ],
      contextMenuOption: {
        baseClass: 'foamTreeContextMenu', // Base tooltip class name.
        typeClass: null, // Type tooltip class name.
        effectClass: null, // Effect tooltip class name.
        inClass: 'in', // Class used to transition stuff in.
        place: 'top', // Default place.
        spacing: null, // Gap between target and tooltip.
        auto: 0 // Whether to automatically adjust place to fit into window.
      }
    }
  },
  methods: {
    init: function () {
      let parentWidth = $('#myGraph').parent().width()
      document.getElementById('myGraph').style.width = parentWidth + 'px'
      document.getElementById('myGraph').style.height = this.height + 'px'

      let contextmenu = this.tooltipMenu()
      this.faom = new CarrotSearchFoamTree({
        id: 'myGraph',
        rainbowStartColor: 'hsla(204, 70%, 53%, 1)',
        rainbowEndColor: 'hsla(204, 70%, 53%, 1)',
        pixelRatio: window.devicePixelRatio || 1,
        onGroupClick: function (event) {
          // Hide the context menu on any click
          contextmenu.hide()
          if (event.secondary) {
            // Show the menu only on right-click
            contextmenu.show()
          }
        },

        onGroupHover: function (event) {
          if (!event.group) contextmenu.hide()
          // Tell the tooltip which group is currently hovered on
          contextmenu.group(event.group)
        },

        // Hide the context menu on zoom, open/close and expose
        onGroupMouseWheel: contextmenu.hide,
        onGroupExposureChanging: contextmenu.hide,
        onGroupOpenOrCloseChanging: contextmenu.hide,
        maxLabelSizeForTitleBar: '10', // Number.MAX_VALUE,
        titleBarTextColor: 'rgba(255, 255, 255, 1)',
        titleBarDecorator: function (options, parameters, variables) {
          variables.titleBarText = 'Right click for menu options'
        },
        rolloutDuration: 6000,
        dataObject: {
          groups: this.parseDatas(this.suggestions)
        }
      })
    },
    parseDatas: function (kwds) {
      let kwDatas = []
      if (kwds) {
        kwds.forEach((kwd) => {
          kwDatas.push({label: kwd.name, weight: kwd.score})
        })
      }
      return kwDatas
    },
    tooltipMenu: function () {
      // A simple utility for tracking mouse position and showing/hiding the context menu.
      // var Tooltip = require('tooltip')
      let tip = new Tooltip('contextmenu', this.contextMenuOption)
      let shown = false
      let pageX, pageY
      let currentGroup
      let self = this

      function hide () {
        tip.hide()
        shown = false
      }

      function show () {
        if (currentGroup && currentGroup.label) {
          // Set some example content on the context menu.
          tip.content(
            "<div class='heading'><strong>" + currentGroup.label + '</strong></div>' +
              "<div><hr class='m-xs'></div>" +
              "<div class='option foamtree-option' data-action='refineSearch' data-kw='" + currentGroup.label + "' ><i class='pe-7s-search pe-fw'></i> Refine current search</a></div>" +
              "<div class='option foamtree-option' data-action='searchOnlySuggestion'  data-kw='" + currentGroup.label + "'><i  class='pe-7s-search pe-fw'></i> Search only with this suggestion</div>" +
              "<div class='option foamtree-option' data-action='addToBiblio'  data-kw='" + currentGroup.label + "'><i class='pe-7s-plus pe-fw'></i> Add to biblio</div>"
          )
          tip.position(pageX, pageY)
          tip.show()
          shown = true
          $('.foamtree-option').on('click', function () {
            let suggestion = this.getAttribute('data-kw')

            if (suggestion) {
              let selectedOption = this.getAttribute('data-action')
              switch (selectedOption) {
                case 'refineSearch':
                  self.refineSearch(suggestion)
                  break
                case 'searchOnlySuggestion':
                  self.onlySearch(suggestion)
                  break
                case 'addToBiblio':
                  self.addToBiblio(suggestion)
                  break
                default:
                  self.$notify({
                    type: 'error',
                    title: 'An error occurred during the last operation! Please try again or refresh the current page.',
                    placement: 'bottom-right'
                  })
              }
            }
          })
        }
      }

      function group (g) {
        currentGroup = g
      }

      // Register a mouse move listener that will remember the coordinates of the mouse pointer
      document.body.addEventListener('mousemove', function (e) {
        pageX = e.pageX
        pageY = e.pageY
      })

      // Hide the context menu when it's clicked
      tip.element.addEventListener('click', function (e) {
        tip.hide()
        e.preventDefault()
      })

      return {
        group: group,
        show: show,
        hide: hide
      }
    },
    refineSearch: function (suggestion) {
      this.$eventHub.$emit('refineWithSuggestion', this.suggestionName(suggestion))
    },
    getCurrentUrlWithSuggestion: function (suggestion) {
      let url = this.$router.currentRoute.fullPath
      let captured = /usedByCs=([^&]+)/.exec(url)
      suggestion = encodeURIComponent(suggestion)
      suggestion = captured ? captured[1] + ',' + suggestion : suggestion
      if (captured) {
        return url.replace(('usedByCs=' + captured[1]), 'usedByCs=' + suggestion)
      } else {
        return (url.match(/\?/)) ? url + '&usedByCs=' + suggestion : url + '?usedByCs=' + suggestion
      }
    },
    addToBiblio: function (suggestion) {
      if (typeof this.biblio !== 'undefined' && this.biblio !== null) {
        this.$requestStack.add('post', '/biblio/' + this.biblio.id + '/add/suggestion', {
          url: this.getCurrentUrlWithSuggestion(suggestion),
          title: suggestion
        }, 0).then((response) => {
          this.$notify({
            type: 'success',
            title: 'Suggestion added !',
            placement: 'bottom-right'
          })
          this.$eventHub.$emit('refreshBiblio', true)
        })
      }
    },
    onlySearch: function (suggestion) {
      this.$eventHub.$emit('onlySearchSuggestion', this.suggestionName(suggestion))
    },
    suggestionName: function (str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },
    draw: function () {
      if (this.faom !== null) {
        this.faom.redraw()
      } else {
        this.init()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/FoamTreeSuggestionsBox.vue